exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-link[data-v-4b71ebfb]{display:none}.username:hover .edit-link[data-v-4b71ebfb]{line-height:19px;display:inline}", ""]);

// exports
